import { Button, Input, Modal } from 'antd'
import { FunctionComponent } from 'react'
import { useInput } from 'react-hanger'
import { useUpdateEffect } from 'react-use'
import { useEditNoteMutation } from '@/api/workspace-api/directory-api'
import { ModalTitle } from '@/components/common/modal-title'
import { TriggerNotesEvent } from '@/components/kol/common/kol-cooperation-detail-drawer/notes/note-list'
import { IrmModalWrapper } from '@/components/kol/irm/common/irm-modal-wrapper'
import { useIntl } from '@/i18n/hooks/use-intl'
import { Note } from '@/types/schema/directory/kol-management'
import logger from '@/utils/logger'

interface EditNoteModalProps {
  open: boolean
  toggleModal: VoidFunction
  note?: Note
  triggerNotesEvent: TriggerNotesEvent
}

const EditNoteModal: FunctionComponent<EditNoteModalProps> = ({
  open,
  toggleModal,
  note,
  triggerNotesEvent,
}) => {
  const { formatMessage } = useIntl()
  const input = useInput('')
  const [editNote, { isLoading }] = useEditNoteMutation()

  const handleEdit = async (): Promise<void> => {
    if (note === undefined) {
      return
    }

    const notePayload: Note = { ...note, Note: input.value }
    try {
      await editNote(notePayload).unwrap()
      triggerNotesEvent({
        action: 'edit',
        id: note.ID,
        fieldValue: input.value,
      })
      toggleModal()
    } catch (error) {
      logger.error(error)
    }
  }

  useUpdateEffect(() => {
    if (open && note !== undefined) {
      input.setValue(note.Note)
    }
  }, [open])

  return (
    <Modal
      centered
      destroyOnClose
      footer={null}
      open={open}
      onCancel={toggleModal}
    >
      <IrmModalWrapper>
        <ModalTitle>{formatMessage({ id: 'irm:lable_edit_note' })}</ModalTitle>
        <Input.TextArea
          rows={4}
          value={input.value}
          onChange={input.onChange}
        />
        <Button loading={isLoading} type='primary' onClick={handleEdit}>
          {formatMessage({ id: 'general:submit_btn' })}
        </Button>
      </IrmModalWrapper>
    </Modal>
  )
}

export default EditNoteModal
